import { Box, Paper, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

/**
 * Header section for the Segmentation editor with the "Segmentación" title.
 */
export function SegmentationEditorHeader() {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom={2}>
      <Typography variant="h6">
        <FormattedMessage
          id="audit.reportDefinitions.segmentation.grouping"
          defaultMessage="Segmentación"
        />
      </Typography>
    </Box>
  );
}
